import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
import { API_PATH } from "../../utils/apis";

const initialState = {
  isLoading: false,
  error: false,
  deleteError: false,
  search: "",
  page: 0,
  perPage: 10,
  total: 0,
  listings: [],
  sortBy: null,
  filters: {
    method: "",
  },
};

const slice = createSlice({
  name: "listing",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getSuccess(state, action) {
      state.isLoading = false;
      state.listings = action.payload.data;
      state.total = parseInt(action.payload.total, 10);
    },
    removeDeleteError(state) {
      state.deleteError = false;
    },
    hasDeleteError(state, action) {
      state.isLoading = false;
      state.deleteError = action.payload;
    },
    deletedSuccess(state, action) {
      const deleted = action.payload.split(",");
      state.listings = state.listings.filter(
        (obj) => !deleted.includes(obj.listingId),
      );
      state.isLoading = false;
    },
    publishSuccess(state, action) {
      const publisheds = action.payload.split(",");
      state.listings = state.listings.map((obj) =>
        publisheds.includes(obj.listingId)
          ? { ...obj, isPublished: parseInt(obj.isPublished, 10) === 1 ? 0 : 1 }
          : obj,
      );
      state.isLoading = false;
    },
    //  SORT & FILTER POSTS
    sortBy(state, action) {
      state.sortBy = action.payload;
    },
    filter(state, action) {
      state.filters.method = action.payload.method;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filter, sortBy } = slice.actions;

export function getListings(
  search,
  stat,
  filters,
  page,
  perpage,
  order,
  sortBy,
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(API_PATH.listings, {
        page,
        perpage,
        order,
        sortBy,
        search,
        status: stat,
        ...filters,
        listing: filters?.listing?.uid || filters?.listing?.listingId || filters?.listing?.id || "",
      });
      const { status, data, total } = response.data;
      if (status === "success") {
        dispatch(slice.actions.getSuccess({ data, total }));
      } else {
        dispatch(
          slice.actions.hasError(
            new Error(
              "We cannot fetch your listings at the moment! Please check back later.",
            ),
          ),
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function deleteListing(remove) {
  return async (dispatch) => {
    dispatch(slice.actions.removeDeleteError());
    try {
      const response = await axios.post(API_PATH.listings, { remove });
      if (response.data.status === "success") {
        dispatch(slice.actions.deletedSuccess(remove));
      } else if (response.data.status === "permission_denied") {
        dispatch(
          slice.actions.hasDeleteError(
            new Error("You do not have permission to perform this action!"),
          ),
        );
      } else {
        dispatch(
          slice.actions.hasDeleteError(
            new Error("An error has occurred! Please try again later."),
          ),
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasDeleteError(error));
    }
  };
}
export function publishListing(publish, enqueueSnackbar) {
  return async (dispatch) => {
    dispatch(slice.actions.removeDeleteError());
    try {
      const response = await axios.post(API_PATH.listings, { publish });
      if (response.data.status === "success") {
        dispatch(slice.actions.publishSuccess(publish));
        enqueueSnackbar("Listing has been updated!", {
          variant: "success",
        });
      } else if (response.data.status === "permission_denied") {
        enqueueSnackbar("You do not have permission to perform this action!", {
          variant: "error",
        });
        // dispatch(
        //   slice.actions.hasDeleteError(
        //     new Error("You do not have permission to perform this action!")
        //   )
        // );
      } else if (response.data.status === "pending_kyc") {
        enqueueSnackbar(
          "Please complete your compliance to perform this action.",
          {
            variant: "error",
          },
        );
        //   dispatch(
        //     slice.actions.hasDeleteError(
        //       new Error("Please complete your compliance to perform this action.")
        //     )
        //   );
        // } else {
        dispatch(
          slice.actions.hasDeleteError(
            new Error("An error has occurred! Please try again later."),
          ),
        );
      }
    } catch (error) {
      enqueueSnackbar("An error has occurred! Please try again later.", {
        variant: "error",
      });
      // dispatch(slice.actions.hasDeleteError(error));
    }
  };
}
